import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-private-program my-25 w-full py-16 max-sm:mt-16 max-sm:py-8',
    container:
      'container flex max-w-[1312px] gap-16 max-xl:flex-col max-xl:gap-10 max-sm:gap-4',
    title:
      'heading-3xl-desk max-sm:heading-3xl w-[580px] shrink-0 max-xl:w-full',
    highlight:
      'font-cormorant-garamond bg-yellow-naos inline-block h-15 rounded-full px-5 text-[60px] leading-[0.8] font-normal italic max-sm:h-[34px] max-sm:px-2 max-sm:text-[34px]',
    content: 'heading-m-block flex flex-col items-start gap-6',
    description: 'heading-l-block',
    button: 'p-0',
    buttonChildren: 'flex items-center gap-5',
    nowrap: 'whitespace-nowrap'
  }
});
